import styled from 'styled-components';

const BoxNameTypeMatch = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & h2.name-type-match {
        font-size: 8px;
        font-weight: 500;
        margin: 0;
        padding: 0;
        font-style: italic;
        text-align: center;
    }
`;  

// Render Nome Type Match
function RenderNameTypeMatchCard(match) {
    return (
        <BoxNameTypeMatch className='box-name-type-match'>
            <h2 className='name-type-match'>{match.type_match.name}</h2>
        </BoxNameTypeMatch>
    )
}

export default RenderNameTypeMatchCard;